import React from "react";
import { X, Check } from "lucide-react";
import { BEFORE, AFTER } from "../mock";

const BeforeAfter = () => {
  return (
    <section id="why" className="py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <span className="text-sm font-bold uppercase tracking-wider text-[var(--brand)]">
            Why Sago
          </span>
          <h2 className="mt-3 font-heading text-4xl lg:text-5xl font-extrabold tracking-tight text-[var(--ink)]">
            The difference we make
          </h2>
          <p className="mt-4 text-lg text-[var(--muted-ink)]">
            See how partnering with Sago Industries transforms your sourcing experience.
          </p>
        </div>

        <div className="mt-14 grid gap-8 lg:grid-cols-2">
          {/* Before */}
          <div className="rounded-3xl border border-red-100 bg-red-50/40 p-8">
            <h3 className="flex items-center gap-3 font-heading text-2xl font-extrabold text-[var(--ink)]">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-red-100 text-red-500">
                <X size={22} />
              </span>
              {BEFORE.title}
            </h3>
            <div className="mt-6 space-y-4">
              {BEFORE.items.map((item) => (
                <div key={item.title} className="rounded-2xl bg-white p-5 shadow-sm">
                  <div className="flex items-start gap-3">
                    <X size={18} className="mt-1 shrink-0 text-red-400" />
                    <div>
                      <p className="font-bold text-[var(--ink)]">{item.title}</p>
                      <p className="mt-1 text-sm leading-relaxed text-[var(--muted-ink)]">{item.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* After */}
          <div className="rounded-3xl border border-[var(--brand)]/15 bg-[var(--brand)]/5 p-8">
            <h3 className="flex items-center gap-3 font-heading text-2xl font-extrabold text-[var(--ink)]">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[var(--brand)] text-white">
                <Check size={22} />
              </span>
              {AFTER.title}
            </h3>
            <div className="mt-6 space-y-4">
              {AFTER.items.map((item) => (
                <div key={item.title} className="rounded-2xl bg-white p-5 shadow-sm">
                  <div className="flex items-start gap-3">
                    <Check size={18} className="mt-1 shrink-0 text-[var(--brand)]" />
                    <div>
                      <p className="font-bold text-[var(--ink)]">{item.title}</p>
                      <p className="mt-1 text-sm leading-relaxed text-[var(--muted-ink)]">{item.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BeforeAfter;
